<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Settings</p>
    </header>
    <section class="modal-card-body">
      <b-field label="Circle Radius">
        <b-slider
          v-model="circleRadiusModel"
          :min="1"
          :max="8"
          :step="0.1"
        ></b-slider>
      </b-field>
      <b-field label="Stroke Width">
        <b-slider
          v-model="strokeWidthModel"
          :min="1"
          :max="5"
          :step="0.1"
        ></b-slider>
      </b-field>
      <b-field label="Label Overlay Scale">
        <b-slider
          v-model="labelScaleModel"
          :min="0"
          :max="2"
          :step="0.1"
        ></b-slider>
      </b-field>
      <b-field label="Ui Color">
        <div class="color-container">
          <chrome-picker v-model="shapeColorModel" />
        </div>
      </b-field>
    </section>
    <footer class="modal-card-foot">
      <button class="button" @click="onClose">
        Close
      </button>
      <div class="spacer"></div>
      <b-button type="is-warning" @click="signout">Signout</b-button>
    </footer>
  </div>
</template>

<script>
import { Chrome } from "vue-color";
import { computed } from "@vue/composition-api";
import router from "@/router";
import useWarnings from "@/composables/useWarnings";
import ui from "@/store/modules/ui";
import annotations from "@/store/modules/annotations";

export default {
  components: {
    "chrome-picker": Chrome
  },
  setup(props, { parent }) {
    const circleRadiusModel = computed({
      get() {
        return ui.circleRadius;
      },
      set(value) {
        ui.setCircleRadius(value);
      }
    });
    const strokeWidthModel = computed({
      get() {
        return ui.strokeWidth;
      },
      set(value) {
        ui.setStrokeWidth(value);
      }
    });
    const labelScaleModel = computed({
      get() {
        return ui.labelScale;
      },
      set(value) {
        ui.setLabelScale(value);
      }
    });
    const shapeColorModel = computed({
      get() {
        return ui.shapeColor;
      },
      set(value) {
        ui.setShapeColor(value.hex);
      }
    });

    const { shouldProceed } = useWarnings();

    const signout = async () => {
      if (!shouldProceed()) return;

      await annotations.resetLocal();
      await ui.signout();
      ui.setHasUnsavedChange(false);
      router.push("/login");
    };

    const onClose = async () => {
      try {
        await ui.putSettings();
      } catch (error) {
        console.error(error);
      }

      parent.close();
    };

    return {
      circleRadiusModel,
      strokeWidthModel,
      shapeColorModel,
      labelScaleModel,
      signout,
      onClose
    };
  }
};
</script>

<style lang="scss" scoped>
.color-container {
  display: flex;
  justify-content: space-around;
}

.spacer {
  flex: 1 1 0;
}
</style>
